import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';

const PromptService = {
  getSystemPrompts: () => {
    return axiosInstance.get('/api/reports/admin/system-prompts/');
  },
  updateSystemPrompt: (id, payload) => {
    return axiosInstance.patch(`/api/reports/admin/system-prompts/${id}/`, payload);
  },
};

export default PromptService;
